import React, { useEffect, useState } from 'react';
import { Card, message } from 'antd';
import { getSoloEvents } from '../../api/event';
import SoloEventsTable from './soloEventsTable/soloEventsTable';

const EventSelector = ({ contestant, onSelectEvent, selectedEvents }) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const soloEvents = await getSoloEvents();
                setEvents(soloEvents);
            } catch (error) {
                console.error('Error fetching solo events:', error);
                message.error('Failed to fetch events');
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, []);

    if (!contestant) {
        return <div>No contestant data available.</div>;
    }

    return (
        <div title="Select Events">
            <SoloEventsTable
                events={events}
                loading={loading}
                openPopup={(event) => console.log("Apply to event:", event)}
                userRole="contestant" // Adjust the role as necessary  
                handleDeleteEvent={(eventId) => console.log("Delete event:", eventId)}
                onSelectEvent={onSelectEvent}
                selectedEvents={selectedEvents} // Make sure this is correctly passed  
            />
        </div>
    );
};

export default EventSelector;  
